import React from "react";
import dayjs from "dayjs";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "ag-grid-community/styles/ag-grid.css";
import AllAppointmentList from "./AllAppointmentList";
import { useState, useMemo, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

ModuleRegistry.registerModules([AllCommunityModule]);

function UpcomingAppointmentList({ data = [], loading }) {
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();

  const upcomingAppointments = useMemo(() => {
    return data.filter((item) => item.status === "Upcoming");
  }, [data]);


  return (
    <>
   <AllAppointmentList data={upcomingAppointments}   loading={loading} />
    </>
  );
}

export default  UpcomingAppointmentList;
